import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={props.poster ? null : videos.cfb.videoUrl}
      title={'Watch college football without cable'}
      subtitle={'Stream Big Ten, CBS, ACC, SEC, ESPN and 200+ live channels'}
      networkSet={'collegeFootball'}
      // teams
      team={props.team}
      matchtickerSportId="111"
      matchtickerLeagueName="College Football"
      matchtickerLeagueId="191261"
      showRedzone={false}
      sportId={sportIds.Football}
      leagueId={leagueIds['NCAA Football']}
      {...props}
    />
  )
}
